export class CurrentAndExpectedDayNumbers {
    CurrentDayNumber;
    ExpectedNumberOfDays;

    constructor(aCurrentDayNumber, aExpectedNumberOfDays) {
        this.CurrentDayNumber = aCurrentDayNumber;
        this.ExpectedNumberOfDays = aExpectedNumberOfDays;
    }
}